import { render, staticRenderFns } from "./PropertyValue.vue?vue&type=template&id=74105c26&scoped=true"
import script from "./PropertyValue.vue?vue&type=script&lang=js"
export * from "./PropertyValue.vue?vue&type=script&lang=js"
import style0 from "./PropertyValue.vue?vue&type=style&index=0&id=74105c26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74105c26",
  null
  
)

export default component.exports